export default __webpack_public_path__ + "static/materhorn-e14149b616ea84bd3c19978470a14afd.jpg";